import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ValueProposition from './components/ValueProposition';
import ArticlePreview from './components/ArticlePreview';
import ArticlesSection from './components/ArticlesSection';
import SocialProof from './components/SocialProof';
import CTASection from './components/CTASection';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://pandabuy.my';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': `${siteUrl}/#organization`,
      name: 'PandabuySheet',
      url: siteUrl,
      description: 'Your go-to resource for the best Pandabuy spreadsheet finds — curated fashion, sneakers, and accessories updated daily.',
      logo: {
        '@type': 'ImageObject',
        url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2ce33a4b04813007a8211abaa8144b8a.jpeg',
      },
      sameAs: [
        'https://kaspreadsheet.com',
      ],
    },
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/#webpage`,
      url: siteUrl,
      name: 'Best Pandabuy Spreadsheet Finds 2026 | Pandabuy Shopping Guide',
      description: 'Discover curated Pandabuy spreadsheet collections with trending fashion, shoes, hoodies, streetwear and accessories.',
      isPartOf: { '@id': `${siteUrl}/#website` },
      about: { '@id': `${siteUrl}/#organization` },
      primaryImageOfPage: {
        '@type': 'ImageObject',
        url: 'https://readdy.ai/api/search-image?query=Dynamic%20urban%20streetwear%20fashion%20collage%20with%20bold%20sneakers%20oversized%20hoodies%20and%20colorful%20accessories%20on%20dark%20textured%20asphalt%20background%2C%20dramatic%20golden%20sunset%20lighting%2C%20editorial%20fashion%20photography%2C%20high%20contrast%20vibrant%20energy%2C%20young%20urban%20culture%20aesthetic&width=1600&height=900&seq=hero-pandabuy-v2&orientation=landscape',
      },
    },
    {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: siteUrl,
      name: 'PandabuySheet',
      description: 'Discover the ultimate Pandabuy Spreadsheet with curated fashion, shoes, hoodies, streetwear and accessories. Find the best Pandabuy spreadsheet finds updated daily for 2026.',
      publisher: { '@id': `${siteUrl}/#organization` },
    },
  ],
};

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <JsonLd data={homeJsonLd} />
      <Navbar />
      <HeroSection />
      <CategoryGrid />
      <ValueProposition />
      <ArticlePreview />
      <ArticlesSection />
      <SocialProof />
      <CTASection />
      <Footer />
    </main>
  );
}